// import anim from "animated-scrollto";

/**
 * scrolls window to exact block
 * @param  {String} selector query selector where you want screen to scroll
 */
// export default function (selector, offset) {
//     let element = document.querySelector(selector);
//     let scrollTop = element.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
//     anim(document.body, scrollTop + parseInt(offset), 700);
//     anim(document.documentElement, scrollTop + parseInt(offset), 700);
// }

function scrollto(el, offset) {
    let element = document.querySelector(el);
    let scrollTop = element.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
    anim(0, scrollTop + parseInt(offset), 1);
}

var anim = function (scrollTop, to, duration) {
    var start = window.scrollY;
    var end = to;
    var change = end - start;
    var currentIteration = 0;
    var totalIterations = duration * 60;

    function animate() {
        var val = Math.easeInOutQuad(currentIteration, start, change, totalIterations);
        // console.log(val)
        currentIteration++;
        scrollTo(0, val);
        if (currentIteration < totalIterations) {
            requestAnimationFrame(animate);
        }
    }

    requestAnimationFrame(animate);
};

Math.easeInOutQuad = function(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
};



export default scrollto;



// WEBPACK FOOTER //
// ./js/util/scrollto.js